﻿import definitions from './LfStyleDefinitions';

/**
 * Media query helper - for use in conjunction with react+styled-components, example usage: 
 * 
 * definitions.breaks = {
 *      ...
 *      medium: 1024,
 *      ...
 * }
 * 
 * const Wrapper = styled.div`
 *   width: 100%;
 *   background-color: blue;
 *   ${mediaQuery.medium(`
 *       background-color: red;
 *   `)};
 * `;
 */

const mediaQuery = Object.keys({...definitions.breaks, custom: ''})
        .reduce((result, sizeName) => {
            result[sizeName] = (styles, customWidth = null) => 
                `@media only screen and (max-width: ${customWidth ? customWidth : `${definitions.breaks[sizeName]}px`}) { ${styles} }`; 
            return result; 
        }, {});

/**
 * Simple clearfix
 */

const clearFix = () => `
    &:after {
        content: "";
        display: table;
        clear: both;
    }
`;

/**
 * Icon helper, se css constant definitions for available icon names 
 */

const iconCode = Object.keys(definitions.iconCodes)
    .reduce((result, iconName) => {
        result[iconName] = () => {
            return `
                content: '${definitions.iconCodes[iconName]}';
                font-family: '${definitions.fonts.icons}';
                font-weight: normal;
            `;
        };

        return result;
    }, {});



export {iconCode, mediaQuery, clearFix};